import cartLogin from './cartLogin/cartLogin.reducer';
import checkout from './checkout/checkout.reducer';
import config from './config/config.reducer';
import demoSessions from './demoSessions/demoSessions.reducer';
import shelf from './mapEditor/shelfTraining/shelfTraining.reducer';
import navigation from './navigation/navigation.reducer';
import noBarcode from './noBarcode/noBarcode.reducer';
import products from './product/product.reducer';
import push from './push/push.reducer';
import sessionMonitor from './sessionMonitor/sessionMonitor.reducer';
import sessionMonitorDetails from './sessionMonitor/sessionMonitorDetails.reducer';
import stores from './store/store.reducer';
import titleBar from './titleBar/titleBar.reducer';
import CPromise from '@whiz-cart/node-shared/cPromise';
import { createStore } from '@whiz-cart/ui-shared/store/createStore';
// @ts-expect-error missing types
import { syncReducer } from '@whiz-cart/ui-shared/sync/sync.reducer.js';
import { urlReducer } from '@whiz-cart/ui-shared/url/url.reducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type StoreUrlParams = {
    storeGuid?: string;
    showHidden?: string;
    showDurationAndPrice?: string;
    sortByNumber?: string;
    sortByWeight?: string;
    sortByUptime?: string;
    showDemoSessions?: string;
};

declare module 'react-redux' {
    interface DefaultRootState extends RootState {}
}

const store = createStore({
    url: urlReducer<StoreUrlParams>,
    navigation,
    products: persistReducer({ key: 'products', storage }, products),
    titleBar,
    mhd: persistReducer({ key: 'mhd', storage }, syncReducer('mhd')),
    demoSession: persistReducer({ key: 'isDemoModeOn', storage }, demoSessions),
    sessionMonitor,
    sessionMonitorDetails,
    noBarcode,
    stores: persistReducer({ key: 'stores_v2', storage }, stores),
    checkout: persistReducer({ key: 'checkout', storage, whitelist: ['cashierGuid'] }, checkout),
    config,
    push: persistReducer({ key: 'push', storage, whitelist: ['topics', 'topicsGlobal', 'topicsActive'] }, push),
    cartLogin: persistReducer({ key: 'cartLogin', storage }, cartLogin),
    shelf: persistReducer({ key: 'shelvesToRestore', storage }, shelf),
});
export const persistor = persistStore(store, null, () => storeRehydration.resolve());
export const storeRehydration = new CPromise<void>();

export default store;
